<template>
  <div v-if="!isClientAdmin">
    <h2>
      <b>Hello <span>{{ userInfo.firstName }} {{ userInfo.lastName }}</span>,</b>
    </h2>
    <span>This is your Client Center.</span>
  </div>
  <div v-else class="client-admin-dashboard">
    <h2>Welcome to Client Center</h2>
    <p>Where you can view employee engagement and manage your wellbeing programs powered by Connect®</p>
    <h3 class="mb-5">Discover What’s Here</h3>
    <div class="discover-box d-flex justify-content-center">
      <div class="container">
        <div class="row">
          <div class="col-md-6 mb-4">
            <div class="small-box d-flex flex-column align-items-center">
              <div class="description mb-4">
                <h4>Eligible Population</h4>
                <p class="mt-3">View the details of your entire eligible employee population.</p>
              </div>
              <b-button class="get-started-btn" size="sm" type="button" variant="outline-danger" @click="goToEligibility">Get Started</b-button>
            </div>
          </div>
          <div class="col-md-6 mb-4">
            <div class="small-box d-flex flex-column align-items-center">
              <div class="description mb-4">
                <h4>Incentive Processing</h4>
                <p class="mt-3">Handle all aspects of program incentives: download templates, and upload incentive files to award employees points.</p>
              </div>
              <b-button class="get-started-btn" size="sm" type="button" variant="outline-danger" @click="goToIncentive">Get Started</b-button>
            </div>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-md-6 mb-4">
            <div class="small-box d-flex flex-column align-items-center">
              <div class="description mb-4">
                <h4>Extracts</h4>
                <p class="mt-3">View member level detailed program reports for managing incentives and rewards.</p>
              </div>
              <b-button class="get-started-btn" size="sm" type="button" variant="outline-danger" @click="goToExtracts">Get Started</b-button>
            </div>
          </div>
          <div class="col-md-6 mb-4">
            <div class="small-box d-flex flex-column align-items-center">
              <div class="description mb-4">
                <h4>Reports</h4>
                <p class="mt-3">Access your Population Insights account for your population reporting needs.</p>
              </div>
              <b-button class="get-started-btn" size="sm" type="button" variant="outline-danger" @click="goToReports">Get Started</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
        <!-- Low Tango Ballance Warning -->
        <b-modal
          v-model="isShowLowTangoBalanceWarningModal"
          hide-footer
          modal-class="low-tange-balance-warning-modal text-center"
          size="md"
          no-close-on-backdrop
          title="Low Tango Balance"
        >
          <p><strong>Your Tango Balance is at $<span>{{ currentTangoBalance }}</span></strong></p>
          <p class="mt-3">Please fund your Tango Rewards account to ensure members continue to earn incentives.</p>
      </b-modal>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import {GETTER_USER_INFO, ACTION_GET_USER_TANGO_BALANCE} from "@/store/modules/users/constants";
import {EventBus} from "@/event-bus";
import {EVENT_ERROR_TOAST_MESSAGE} from "@/store/events";

export default {
  name: "welcome",
  props: {
    fromLogin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    userInfo() {
      return this.getUserInfo;
    },
    isClientAdmin() {
      return this.userInfo.roles
        && this.userInfo.roles.data
        && this.userInfo.roles.data.length
        && this.userInfo.roles.data[0].name === 'client_admin';
    },
    canAccessEligibilityPage() {
      return this.$can("index", this.$entities.employee);
    },
    canAccessIncentivePage() {
      return this.$can("upload_incentive", this.$entities.employee);
    },
    canAccessExtractsPage() {
      return this.$can("index", this.$entities.extract);
    },
    canAccessReportsPage() {
      return this.$can("access_to_sisense", this.$entities.report);
    },
    ...mapGetters({
      getUserInfo: GETTER_USER_INFO
    })
  },
  data() {
    return {
      userPermissionsData: null,
      isShowLowTangoBalanceWarningModal: false, 
      currentTangoBalance: 0
    };
  },
  methods: {
    ...mapActions({
      getUserTangoBalance: ACTION_GET_USER_TANGO_BALANCE
    }),
    goToEligibility() {
      if (this.canAccessEligibilityPage) {
        this.$router.push({name: this.$dashboardRoute.items.eligibility.name});
      } else {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          "You don't have permission to do this action"
        );
      }
    },
    goToIncentive() {
      if (this.canAccessIncentivePage) {
        this.$router.push({name: this.$dashboardRoute.items.testUploadFile.name});
      } else {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          "You don't have permission to do this action"
        );
      }
    },
    goToExtracts() {
      if (this.canAccessExtractsPage) {
        this.$router.push({name: this.$dashboardRoute.items.extracts.name});
      } else {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          "You don't have permission to do this action"
        );
      }
    },
    goToReports() {
      if (this.canAccessReportsPage) {
        this.$router.push({name: this.$dashboardRoute.items.sisense.name});
      } else {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          "You don't have permission to do this action"
        );
      }
    }
  },
  mounted() {
    if(this.fromLogin){
      this.getUserTangoBalance({
        clientId: this.userInfo.client_admin_employer_id
      }).then(result => {
        if(result.warningLevel === "HIGHEST" || result.warningLevel === "HIGH"){
          this.isShowLowTangoBalanceWarningModal = true;
          if(result.tangoCurrentBalance) {
            this.currentTangoBalance = result.tangoCurrentBalance;
          }
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/styles/_core-variables.scss";
.container {
  max-width: 750px;
}
.client-admin-dashboard{
  .get-started-btn{
    color: #d32e2e;
    font-size: 16px;
    font-weight: 600;
    width: 138px;
    height: 32px;
    padding: 0;
  }
  .get-started-btn:hover{
    color: #FFF;
    background-color: #d32e2e;
  }
}

.low-tange-balance-warning-modal{
  font-size: 16px;
  .modal-content{
    border-radius: 5px;
    border-color: $grey-8;
  }
  .modal-header{
    border: none;
    padding: 24px;
    h5{
      font-size: 20px;
      font-weight: 600;
    }
    button{
      font-size: 40px;
      font-weight: 100;
      padding-top: 5px;
      color: $near-black;
    }
    strong{
      font-weight: 600;
    }
  }
  .modal-body{
    padding: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Welcome.vue